module.exports = __webpack_public_path__ + "static/media/icon-confirm-transaction.afe4ddcd.png";